/*
 * O conteúdo do menu "Visualizações recentes" do mapa do tópico: busca os
 * dias ao abrir (com um indicador de carregamento) e escolhe entre o gráfico,
 * com mais de dois dias, e os números lado a lado.
 */
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { t } from '../../../utils/settings';
import TopicViews from './TopicViews';
import { once } from '../../../utils/chunkGate';
import { cachedViewStats, fetchViewStats, fullWindow } from './viewStats';
// O gráfico é um chunk: pedido junto com os números, então chega com eles.
const loadChart = once(() => import(/* webpackChunkName: 'forum/features/stats/views/TopicViewsChart', webpackMode: 'lazy-once' */ './TopicViewsChart').then(mod => mod.default));
let TopicViewsChart = null;
let chartFailed = false;

/**
 * Busca os números (e o gráfico) antes do clique, ao passar o mouse ou focar
 * "visualizações": o menu abre já com o conteúdo, sem o carregando que o fazia
 * mudar de tamanho na frente da pessoa.
 */
export function prefetchTopicViews(discussion, views) {
  if (!TopicViewsChart && !chartFailed) {
    loadChart().then(chart => TopicViewsChart = chart).catch(() => chartFailed = true);
  }
  if (!cachedViewStats(discussion)) fetchViewStats(discussion, views).catch(() => {});
}
export default class TopicViewsMenu extends Component {
  loading = true;
  failed = false;
  oninit(vnode) {
    super.oninit(vnode);
    this.data = cachedViewStats(this.attrs.discussion);
    this.loading = !this.data;
    if (!TopicViewsChart) {
      loadChart().then(chart => TopicViewsChart = chart).catch(() => chartFailed = true).finally(() => m.redraw());
    }
    if (!this.data) {
      fetchViewStats(this.attrs.discussion, this.attrs.views).then(data => {
        this.data = data;
      }).catch(() => {
        // O app.request já mostrou o alerta de erro, como o dialog.alert de lá.
        this.failed = true;
      }).finally(() => {
        this.loading = false;
        m.redraw();
      });
    }
  }

  /**
   * Os dias do menu. Com dias gravados, a janela inteira (30 dias, ou desde a
   * criação do tópico) com zero nos dias sem registro; sem nenhum, o total
   * em hoje.
   */
  stats() {
    if (!this.data) return [];
    if (this.data.estimated) return this.data.stats;
    return fullWindow(this.data.stats, this.attrs.discussion.createdAt());
  }
  view() {
    const stats = this.stats();
    const chartPending = !TopicViewsChart && !chartFailed && stats.length > 2;
    if (this.loading || chartPending) return m(LoadingIndicator, {
      size: "small",
      display: "block"
    });
    if (this.failed || !this.data) return m("div", {
      className: "CanelaViewsChart CanelaViewsChart--error"
    }, t('stats.views.chart_error'));

    // `shouldShowViewsChart`: o gráfico só a partir de três dias.
    return stats.length > 2 && TopicViewsChart ? m(TopicViewsChart, {
      stats: stats
    }) : m(TopicViews, {
      stats: stats
    });
  }
}
flarum.reg.add('ramon-canela', 'forum/features/stats/views/TopicViewsMenu', TopicViewsMenu);flarum.reg.addChunkModule('forum/features/stats/views/TopicViewsChart', './src/forum/features/stats/views/TopicViewsChart.tsx', 'ramon-canela', 'forum/features/stats/views/TopicViewsChart');